import http from '../http'

export default {
  // 获取国家列表
  getCountryList(data: object) {
    return http.post('/withoutsign/country', data)
  },
  // 获取国家列表——分区，创建公会的时候用到
  getCountryListByRegion(data: object) {
    return http.post('/withoutsign/country/region', data)
  },
  // 根据ID查询用户
  getUserById(data: object) {
    return http.post('/withoutsign/payermax/user/verify', data)
  },
  login(data: object) {
    return http.post('/withoutsign/user/loginweb', data)
  },
  // 查询用户信息
  getUsreInfo(data: object) {
    return http.post('/web/user/info', data)
  },
  // 获取上传文件地址
  getUploadUrl(data: object) {
    return http.post('/web/upload', data)
  },
  // 上传文件，注意：data必须为formData对象，包含file和filePathName两个属性，上传文件请直接使用src/utils/common.ts中的uploadFile方法
  uploadFile(url: string, data: object) {
    return http.put(url, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // 获取配置
  getSettings(data: object) {
    return http.post('/web/settings/kv', data)
  },
}
